import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import MuiSelect, { type SelectProps } from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import clsx from 'clsx';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import './Select.scss';

type TPHSelectProps = SelectProps & { helperText?: string; fullWidth?: boolean };

export const Select = React.forwardRef<HTMLDivElement, TPHSelectProps>((props, ref) => {
    const { label, className, disabled, error, readOnly, style, helperText, fullWidth, ...inputProps } = props;
    
    return (
        <FormControl ref={ref} disabled={disabled} error={error}
            className={clsx('ms_select', readOnly && 'readonly', className)}
            variant="filled" style={style} fullWidth={fullWidth}
        >
            <InputLabel>{label}</InputLabel>
            <MuiSelect
                input={<InputBase/>}
                IconComponent={KeyboardArrowDownRoundedIcon}
                role="combobox"
                MenuProps={{
                    className: 'ms_select_menu',
                    PaperProps: {
                        className: "ms_select_menu_surface",
                        elevation: 0
                    }
                }}
                readOnly={readOnly}
                {...inputProps}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
});